<!-- Modal Followers-->
<div class="modal fade contenedor-modal" id="modalFollowers" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content --cm-white-s-90 contenedorModal">
            <div class="modal-body p-0">
                <app-modal-follow *ngIf="followers" [list]="followers" (onClose)="closeModalFollowers()">
                </app-modal-follow>
            </div>
        </div>
    </div>
</div>
<!-- ----------------------------------------------------------------------------------------------------------------- -->

<!-- Modal Following-->
<div class="modal fade contenedor-modal" id="modalFollowing" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content --cm-white-s-90 contenedorModal">
            <div class="modal-body p-0">
                <app-modal-follow *ngIf="followings" [list]="followings" (onClose)="closeModalFollowing()">
                </app-modal-follow>
            </div>
        </div>
    </div>
</div>
<!-- ----------------------------------------------------------------------------------------------------------------- -->

<div class="pantalla clara" *ngIf="authorised == true">
    <div class="container" *ngIf="!loading">
        <div class="row">
            <div class="col-12 text-center">
                <span class="tituloNombre">{{perfilNombre}}</span>
                <button class="btn pink text-white text-center botonSeguir" *ngIf="!following && showFollow"
                    (click)="onFollow()">
                    Seguir </button>
                <button class="btn pink text-white text-center botonSeguir" *ngIf="following && showFollow"
                    (click)="onUnFollow()">
                    Siguiendo </button>
            </div>
        </div>

        <div class="row justify-content-center my-3">
            <div class=" col-sm-4 col-lg-2 px-0 text-center statContainter">
                Vistas Totales
                <div class="col px-0">
                    {{perfilVistasTotales}}
                </div>
            </div>
            <div class=" col-sm-4 col-lg-2 px-0 text-center border-left statContainter">
                Este mes
                <div class="col px-0">
                    {{perfilVistasMes}}
                </div>
            </div>
            <div class=" col-sm-4 col-lg-2 px-0 text-center border-left statContainter" *ngIf="followerAmount > 0">
                <a class="followHref" (click)="onOpenFollowers()">
                    Seguidores
                    <div class="col px-0">
                        {{followerAmount}}
                    </div>
                </a>
            </div>
            <div class=" col-sm-4 col-lg-2 px-0 text-center border-left statContainter" *ngIf="followingAmount > 0">
                <a class="followHref" (click)="onOpenFollowing()">
                    Siguiendo
                    <div class="col px-0">
                        {{followingAmount}}
                    </div>
                </a>
            </div>
        </div>

        <div class="row">
            <div class="col-12 ">
                <div class="card card-body cardBody p-5">
                    <div class="row px-lg-5">

                        <div class="col-12 p-lg-5 contenedorPeliculas">

                            <!-- Biografía -->
                            <div *ngIf="account.bio">
                                <h3 class="font-weight-bold mb-3">Biografía</h3>
                                <h5 class="text-muted"> {{account.bio}} </h5>

                                <br><br>
                            </div>


                            <app-poster-list [title]="tituloFavoritos" [movies]=" perfilPelisFavoritas">
                            </app-poster-list>

                            <br><br>

                            <app-poster-list [title]="tituloRecientes" [movies]=" perfilPelisRecientes">
                            </app-poster-list>

                            <br><br>

                            <div class="contenedorComentarios">
                                Comentarios recientes
                                <div class="row px-2">
                                    <div class="col-12 my-3 line "></div>
                                </div>
                                <div class="div listaComentariosContenedor" *ngIf="perfilUltimosComentarios.length > 0">
                                    <ul class="list-group listaComentarios">
                                        <li *ngFor="let comments of perfilUltimosComentarios">
                                            <app-comment-item [comment]="comments"> </app-comment-item>
                                        </li>
                                    </ul>
                                </div>
                                <div class="div textoSinComentariosContenedor"
                                    *ngIf="perfilUltimosComentarios.length == 0">
                                    <div class="text-left textoSinComentarios"> Sin comentarios para mostrar </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>